import styled from 'styled-components';

export const BtnRow = styled.div`
  margin-top: 39px;
  display: flex;
  flex-direction: column;
`

export const BtnAzureRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const BtnClassicLoginRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const HorizontalLine = styled.hr`
  height: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: ${({ ml }) => (ml ? ml : '0px')};
  margin-right: ${({ mr }) => (mr ? mr : '0px')};
  flex: 1;
  color: ${({ theme, color }) => (color ? color : theme.black)};
`